function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#comment_new_svg__clip0_1096_58)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.333 6.667c0-1.867 0-2.8.364-3.514.32-.627.83-1.137 1.456-1.456.713-.364 1.647-.364 3.514-.364h2.666c1.867 0 2.8 0 3.514.364.627.32 1.137.83 1.456 1.456.364.713.364 1.647.364 3.514v6.114c0 .684 0 1.026-.109 1.24a1 1 0 01-.962.544c-.239-.017-.532-.193-1.118-.545-.35-.21-.525-.315-.709-.397a3.331 3.331 0 00-.959-.266c-.2-.024-.403-.024-.811-.024H6.667c-1.867 0-2.8 0-3.514-.363a3.333 3.333 0 01-1.456-1.457C1.333 10.8 1.333 9.867 1.333 8V6.667z",
  stroke: "#666A72",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "comment_new_svg__clip0_1096_58"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

var SvgCommentNew = function SvgCommentNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCommentNew;